import { z } from "zod";
export const CustomDomainWhiteLabelV1Schema = z
    .object({
    schemaVersion: z.literal("custom-domain-white-label.v1.0"),
    localTargetedProofComplete: z.literal(true),
    hostedOrExternalProofClaimed: z.literal(false),
    recordedAt: z.string().datetime(),
})
    .strict();
export function recordLocalCustomDomainWhiteLabel(recordedAt) {
    return CustomDomainWhiteLabelV1Schema.parse({
        schemaVersion: "custom-domain-white-label.v1.0",
        localTargetedProofComplete: true,
        hostedOrExternalProofClaimed: false,
        recordedAt,
    });
}
//# sourceMappingURL=custom-domain-white-label.js.map